function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UseCasesService from '@/apps/attributes/services/use_cases_service';
import { mapMutations, mapState } from 'vuex';
import tasks from '@/js/tasks';
import moment from 'moment';
import search_engine_service from '@/apps/attributes/services/search_engine_service';
import { localPaginationMixin } from '@/mixins/local_pagination';
export default {
  name: 'EditAttributeGroupComponent',
  props: {
    item: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      label: {
        group_name: this.translate('attributes.label.group_name'),
        group_description: this.translate('attributes.label.group_description')
      },
      form: {
        group_description: null,
        group_name: null
      },
      valid: false,
      q: '',
      title: 'Add',
      attributesList: [],
      keyTable: 0,
      tab: null,
      encontrado: {
        'found': 0,
        'page': 1,
        'per_page': 5,
        'q': '',
        'search_time_ms': 0,
        'busqueda': []
      },
      filtro: {
        category: [],
        category_comma: '',
        q: '',
        per_page: 5,
        page: 1,
        not_null_without_value: true,
        not_null_min: 0,
        not_null_max: 100,
        include_no_available: false
      },
      pagination: {
        search: {
          current: 1,
          limit: 5,
          total: 0
        }
      },
      isLoading: false,
      atttributes_edit: []
    };
  },
  mixins: [localPaginationMixin],
  beforeMount: function beforeMount() {
    this.getAttributes();
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName'])), {}, {
    rules: function rules() {
      var _this = this;
      return {
        name: [function (v) {
          return !!v || _this.translate('reglas.nombre');
        }, function (v) {
          return v && v.length >= 3 || _this.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 50 || _this.translate('reglas.nombre_max');
        }],
        description: [function (v) {
          return !!v || _this.translate('reglas.field');
        }, function (v) {
          return v && v.length >= 3 || _this.translate('reglas.nombre_min');
        }, function (v) {
          return v && v.length <= 200 || _this.translate('reglas.nombre_max');
        }]
      };
    },
    headers: function headers() {
      return [{
        text: this.translate('attributes.search.table_search_list.name'),
        value: 'nombre'
      }, {
        text: this.translate('attributes.search.table_search_list.description'),
        value: 'descripcion'
      }, {
        text: this.translate('attributes.search.table_search_list.category'),
        value: 'categoria'
      }, {
        text: this.translate('attributes.search.table_search_list.data_type'),
        value: 'tipo_dato'
      }, {
        text: this.translate('attributes.search.table_search_list.percentage'),
        value: 'no_nulo'
      }, {
        text: '',
        value: 'actions'
      }];
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['setShowLoading'])), {}, {
    getAttributes: function getAttributes() {
      var _this2 = this;
      this.setShowLoading(true);
      var listaAdicional = [];
      UseCasesService.getAttributesGroupsFields(this.companyCode, this.item.id).then(function (response) {
        _this2.form.group_name = response.data.metadata[0].preference_group_name;
        _this2.form.group_description = response.data.metadata[0].group_description;
        _this2.form.group_date = moment(String(response.data.metadata[0].creation_date)).format('DD/MM/YYYY hh:mm:ss a');
        _this2.atttributes_edit = Object.values(response.data.attributes).map(function (item) {
          _this2.filtro.category_comma = item.attribute_category;
          _this2.filtro.q = item.attribute_name;
          var aditional = search_engine_service.getBuscadorAtributosEspecifico(_this2.filtro);
          listaAdicional.push(aditional);
          return {
            nombre: item.attribute_name,
            categoria: item.attribute_category,
            descripcion: '-',
            tipo_dato: '-',
            no_nulo: ''
          };
        });
      }).catch(function (err) {
        tasks.toast.error(_this2.translate('error_messages.error_general'), _this2.translate('titles.error'));
      }).finally(function () {
        _this2.setShowLoading(false);
        Promise.all(listaAdicional).then(function (values) {
          values.forEach(function (value) {
            _this2.editedIndex = _this2.atttributes_edit.findIndex(function (item) {
              return item.categoria == value.busqueda[0].categoria && item.nombre == value.busqueda[0].nombre;
            });
            if (_this2.editedIndex >= 0) {
              _this2.editedItem = Object.assign({}, value.busqueda[0]);
              Object.assign(_this2.atttributes_edit[_this2.editedIndex], _this2.editedItem);
            }
          });
          _this2.attributesList = _this2.atttributes_edit;
        });
      });
    },
    sendToSearch: function sendToSearch() {
      console.log('search');
      this.filtro.q = this.q;
      if (this.q == null) {
        this.q = '';
      }
      this.buscarTerminos();
    },
    buscarTerminos: function buscarTerminos() {
      var _this3 = this;
      this.isLoading = true;
      search_engine_service.getBuscadorAtributos(this.filtro).then(function (response) {
        _this3.isLoading = false;
        _this3.encontrado = response;
        _this3.existeBusqueda = _this3.encontrado.found > 0;
        if (_this3.existeBusqueda) {
          _this3.encontrado.busqueda = _this3.encontrado.busqueda.map(function (v) {
            return _objectSpread(_objectSpread({}, v), {}, {
              status: false
            });
          });
          _this3.PreselectionData();
        } else {
          _this3.encontrado.busqueda = [];
        }
      });
    },
    PreselectionData: function PreselectionData() {
      var _this4 = this;
      this.atttributes_edit.forEach(function (a) {
        _this4.editedIndex = _this4.encontrado.busqueda.findIndex(function (item) {
          return item.categoria == a.categoria && item.nombre == a.nombre;
        });
        if (_this4.editedIndex >= 0) {
          _this4.editedItem = Object.assign({}, a);
          Object.assign(_this4.encontrado.busqueda[_this4.editedIndex], _this4.editedItem);
        }
      });
    },
    next: function next(page) {
      this.filtro.page = page;
      this.buscarTerminos();
      this.isLoading = false;
    },
    addAllItem: function addAllItem() {
      var _this5 = this;
      var counter = 0;
      this.encontrado.busqueda.forEach(function (item) {
        if (item.status === true) {
          counter++;
        }
      });
      if (counter < this.encontrado.busqueda.length) {
        this.encontrado.busqueda.forEach(function (item) {
          if (item.status === false) {
            item.status = true;
            _this5.addItem(item);
          }
        });
      } else {
        this.encontrado.busqueda.forEach(function (item) {
          _this5.removeItem(item);
          item.status = false;
        });
      }
    },
    editItem: function editItem(item) {
      this.editedIndex = this.encontrado.busqueda.indexOf(item);
      this.editedItem = Object.assign({}, item);
      console.log(this.editedItem);
      if (this.editedItem.status) {
        this.editedItem.status = false;
        this.removeItem(item);
      } else {
        console.log('---add---');
        this.editedItem.status = true;
        this.addItem(item);
      }
      Object.assign(this.encontrado.busqueda[this.editedIndex], this.editedItem);
    },
    addItem: function addItem(item) {
      var elemento = {
        nombre: item.nombre,
        descripcion: item.descripcion,
        no_nulo: item.no_nulo,
        tipo_dato: item.tipo_dato,
        categoria: item.categoria,
        proyecto: item.proyecto,
        dataset: item.dataset,
        tabla: item.tabla,
        status: true
      };
      this.atttributes_edit.push(elemento);
    },
    removeItem: function removeItem(item) {
      var index = this.atttributes_edit.findIndex(function (a) {
        return a.nombre == item.nombre && a.categoria == item.categoria;
      });
      this.atttributes_edit.splice(index, 1);
    },
    translate: function translate(key) {
      return this.$i18n.t(key);
    },
    onUpdate: function onUpdate() {
      var _this6 = this;
      if (!this.$refs.form.validate()) {
        return;
      }
      var rDetailAttributes = this.atttributes_edit.map(function (item) {
        return {
          attribute_name: item.nombre,
          attribute_object_name: item.tabla,
          attribute_scheme_name: item.dataset,
          attribute_project_name: item.proyecto,
          attribute_category: item.categoria
        };
      });
      var params = {
        preference_group_name: this.form.group_name,
        group_description: this.form.group_description,
        pagroup: rDetailAttributes.length > 0 ? rDetailAttributes : null
      };
      UseCasesService.updateAttributeGroup(this.companyCode, this.item.id, params).then(function (response) {
        console.log('response');
        console.log(response);
        if (response.code === 200) {
          tasks.toast.success('Se está procediendo con la actualización.');
        }
      }).catch(function (err) {
        if (err.response.data.data.error_info[0].type === 'type_error.none.not_allowed') {
          tasks.toast.error(_this6.translate('error_messages.error_general'), _this6.translate('attributes.error.required'));
        } else {
          tasks.toast.error(_this6.translate('error_messages.error_general'), _this6.translate('titles.error'));
        }
      }).finally(function () {
        _this6.$emit('close');
      });
    }
  })
};